import { Provider } from '@angular/core';
import { resolveSettingsApiUrl, SETTINGS_API_URL } from './settings-api.tokens';

export function provideSettingsApi(apiUrl: string): Provider[] {
  return [
    { provide: SETTINGS_API_URL, useValue: resolveSettingsApiUrl(apiUrl) },
  ];
}
